import { ApplicationAccess, TenantAccess, UserAccess } from './user-access.model';

export interface SignInRequest {
  username: string;
  password: string;
}

export interface TokenRefreshRequest {
  refresh_token: string;
}

/** Body de `PUT /users/change-temporary-password` (Jackson SNAKE_CASE). */
export interface ChangeTemporaryPasswordRequest {
  username: string;
  temporary_password: string;
  new_password: string;
}

/** Body de `POST /users/forgot-password` (Jackson SNAKE_CASE). */
export interface ForgotPasswordRequest {
  email: string;
  callback_url?: string;
}

/** Resposta OAuth 2.0 do eq-auth-api (Jackson SNAKE_CASE). */
export interface TokenResponse {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  refresh_expires_in?: number;
  token_type: string;
  scope?: string;
}

export interface AuthContext {
  tenantId: string;
  tenantCode: string;
  tenantName: string;
  applicationId: string;
  applicationCode: string;
  applicationName: string;
}

export interface StoredAuthSession extends TokenResponse {
  expires_at: number;
  authenticated_at?: number;
  context?: AuthContext;
  userAccess?: UserAccess;
}

export function buildAuthContext(tenant: TenantAccess, application: ApplicationAccess): AuthContext {
  return {
    tenantId: tenant.id,
    tenantCode: tenant.code,
    tenantName: tenant.name,
    applicationId: application.id,
    applicationCode: application.code,
    applicationName: application.name,
  };
}
